// extracted by mini-css-extract-plugin
export default {"mobileMenu":"styles_mobileMenu__55m6n"};